import ApiService from './ApiService'

export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: 'user/login',
        method: 'post',
        data,
    })
}

export async function apiCWHostedSignIn(data) {
    return ApiService.fetchData({
        url: 'user/cwm-hosted-login',
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: 'user/sign-out',
        method: 'post',
        data,
    })
}

export async function apiValidateSignIn() {
    return ApiService.fetchData({
        url: 'user/validate',
        method: 'get',
    })
}